import type { User } from "./types";

type ThemeColors = { primary: string; secondary: string; tertiary: string; banner: string };

const PRESETS: Record<string, ThemeColors> = {
  "liquid glass": { primary: "#8FEFFF", secondary: "#8BAEC8", tertiary: "#F472B6", banner: "#0B3B4A" },
  "neon cyan": { primary: "#35D7FF", secondary: "#8BAEC8", tertiary: "#F472B6", banner: "#0B3B4A" },
  "magenta drift": { primary: "#FF4DFF", secondary: "#35D7FF", tertiary: "#FFB64D", banner: "#332052" },
  "amber ops": { primary: "#FFB64D", secondary: "#35D07F", tertiary: "#35D7FF", banner: "#4A3514" },
  "emerald crew": { primary: "#35D07F", secondary: "#8FEFFF", tertiary: "#FFB64D", banner: "#173B2B" },
  "violet quantum": { primary: "#A78BFA", secondary: "#38BDF8", tertiary: "#F472B6", banner: "#2D1B69" },
  "crimson alert": { primary: "#FF4D5E", secondary: "#FFB64D", tertiary: "#38BDF8", banner: "#421A24" },
  "ice blue": { primary: "#8FEFFF", secondary: "#A78BFA", tertiary: "#35D07F", banner: "#123A5A" },
  "solar gold": { primary: "#FFD970", secondary: "#FFB64D", tertiary: "#8FEFFF", banner: "#46351D" },
  "rose plasma": { primary: "#F472B6", secondary: "#38BDF8", tertiary: "#A78BFA", banner: "#4A1E3A" },
  "deep space": { primary: "#94A3B8", secondary: "#8BAEC8", tertiary: "#38BDF8", banner: "#182232" },
  nebula: { primary: "#38BDF8", secondary: "#8BAEC8", tertiary: "#F472B6", banner: "#223044" }
};

const DEFAULT_THEME = PRESETS.nebula;

function validHex(value?: string) {
  const trimmed = value?.trim();
  return trimmed && /^#[0-9a-f]{6}$/i.test(trimmed) ? trimmed.toUpperCase() : undefined;
}

function rgbChannels(value: string) {
  const hex = value.slice(1);
  return `${Number.parseInt(hex.slice(0, 2), 16)}, ${Number.parseInt(hex.slice(2, 4), 16)}, ${Number.parseInt(hex.slice(4, 6), 16)}`;
}

export function resolveWebTheme(themePreset?: string, bannerColor?: string): ThemeColors {
  const preset = PRESETS[themePreset?.trim().toLowerCase() || ""] || DEFAULT_THEME;
  return { ...preset, banner: validHex(bannerColor) || preset.banner };
}

export function applyWebTheme(user?: Pick<User, "themePreset" | "bannerColor"> | null) {
  const theme = resolveWebTheme(user?.themePreset, user?.bannerColor);
  const root = document.documentElement;
  root.style.setProperty("--primary", theme.primary);
  root.style.setProperty("--cyan", theme.primary);
  root.style.setProperty("--secondary", theme.secondary);
  root.style.setProperty("--violet", theme.tertiary);
  root.style.setProperty("--theme-banner", theme.banner);
  root.style.setProperty("--theme-banner-rgb", rgbChannels(theme.banner));
  root.style.setProperty("--theme-primary-rgb", rgbChannels(theme.primary));
}
